"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withManufacturers = undefined;

var _ManufacturersContainer = require("../components/manufacturer/ManufacturersContainer");

var _ManufacturersContainer2 = _interopRequireDefault(_ManufacturersContainer);

var _nodeToolbox = require("@esnpm/node-toolbox");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var withManufacturers = exports.withManufacturers = (0, _nodeToolbox.wrapComponent)(_ManufacturersContainer2.default);